import {Component} from '@angular/core';

@Component({
  selector: 'app-general-settings-help',
  standalone: true,
  imports: [],
  templateUrl: './general-settings-help.component.html',
  styleUrl: './general-settings-help.component.scss'
})
export class GeneralSettingsHelpComponent {

}
